/**
 * Maquette suivi e-factures. Aucun dépôt, aucune écriture.
 */
import { useState } from "react";
import { PageHeader } from "../components/PageHeader";
import { EinvoiceIssued } from "../features/einvoice/EinvoiceIssued";
import { EinvoiceReceived } from "../features/einvoice/EinvoiceReceived";
import "../features/einvoice/einvoice.css";
import "../features/clients/clientShow.css";
import "../features/dashboard/dashboard.css";
import type { Lane } from "../features/einvoice/types";

const LANES: { id: Lane; label: string }[] = [
  { id: "issued", label: "Émises" },
  { id: "received", label: "Reçues" },
];

export function EinvoicePage() {
  const [lane, setLane] = useState<Lane>("issued");

  return (
    <div className="fx-einv">
      <PageHeader title="Envoi électronique" />
      <p className="fx-demo-banner">Maquette — données fictives, rien n’est envoyé.</p>
      <div className="fx-fiche-tabs" role="tablist" aria-label="Sens des factures">
        {LANES.map((item) => (
          <button
            key={item.id}
            type="button"
            role="tab"
            aria-selected={lane === item.id}
            className={lane === item.id ? "is-on" : ""}
            onClick={() => setLane(item.id)}
          >
            {item.label}
          </button>
        ))}
      </div>
      {lane === "issued" ? <EinvoiceIssued /> : <EinvoiceReceived />}
    </div>
  );
}
